import ManageAnswerCommentsPage from './manageAnswerCommentsPage'

export { ManageAnswerCommentsPage }
